<template>
    <div class="agenda-destinatarios">
        <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"/>
        <b-card style="margin: 20px">
            <b-card-header header-tag="header" class="p-1" role="tab">Agenda de destinatarios</b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12">
                        <base-button type="success" @click="addContact()">Nuevo</base-button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <base-input
                            class="input-group-alternative mb-3"
                            placeholder="Buscar..."
                            addon-left-icon="fa fa-fw fa-search"
                            v-model="contactsFilter"
                        />
                    </div>
                </div>
                <div v-for="(item,index) in filteredContacts" v-bind:key="index">
                    <div class="row" style="padding: 5px; border-bottom: 1px solid #d6d4d4; margin-right: 0; margin-left: 0">
                        <div class="col-10">
                            <div class="row">
                                <div class="col-12 item-name">
                                    <span>{{item.Name}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 item-bank-name">
                                    <span>{{item.BankName}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <span>{{item.CBUCVU}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-2 text-right mt-4">
                            <i class="fa fa-eye fa-fw" style="cursor: pointer;" @click="verDetallesContacto(item)" />
                            <i class="fa fa-trash fa-fw" style="cursor: pointer;margin-left:40px;" @click="preDeleteContact(item)" />
                        </div>
                    </div>
                </div>
            </b-card-body>
        </b-card>
        <b-modal id="modalDetallesContacto" v-model="mostrarModalDetallesContacto" title="Detalle de contacto">
            <div class="text-center" style="padding:0 40px;">
                <div class="text-left">
                    <label style="margin-right:5px;">Nombre de referencia:</label>
                    <b>{{Referencia}}</b>
                </div>
                <div class="text-left">
                    <label style="margin-right:5px;">Propietarios/s:</label>
                    <b>{{NombresPropietarios}}</b>
                </div>
                <div class="text-left">
                    <label style="margin-right:5px;">CUIT/s / CUIL/s propietarios/s:</label>
                    <b>{{CuitCuilPropietarios}}</b>
                </div>
                <div class="text-left">
                    <label style="margin-right:5px;">CBU/CVU:</label>
                    <b>{{CBUCVU}}</b>
                </div>
                <div class="text-left">
                    <label style="margin-right:5px;">Banco:</label>
                    <b>{{Banco}}</b>
                </div>
                <div class="text-left">
                    <label style="margin-right:5px;">Alias:</label>
                    <b>{{Alias}}</b>
                </div>
            </div>
            <template v-slot:modal-footer>                
                <div class="w-100">
                    <b-button
                        class="float-left"
                        @click="cerrarModalDetallesContacto()"
                        style="border-color:#f5365c;color:#f5365c;font-weight:100;">
                        Volver
                    </b-button>
                </div>                    
            </template>
        </b-modal>
        <pin-validation ref="pin-validation"
        :showModal.sync="showModalPinValidation"
        v-on:validPin="onValidPin"
        v-on:loadUsePaymentPin="onLoadUsePaymentPin">
        </pin-validation>
    </div>
</template>

<style lang="scss">
    .agenda-destinatarios {
        .item-name {
            color: #ff5855;
        }

        .item-bank-name {
            font-weight: bolder;
        }
    }
</style>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import confirmHelper from "@/helpers/confirmHelpers";
import notificationHelpers from '@/helpers/notificationHelpers';
import PinValidation from '@/views/Pin/PinValidation';

export default {
    components: {
    "pin-validation": PinValidation
    },
    name: "AgendaDestinatarios",
    data() {
        return {
            contacts: [],
            contactsFilter: '',
            mostrarModalDetallesContacto: false,
            Referencia: '',
            NombresPropietarios: '',
            CuitCuilPropietarios: '',
            Banco: '',
            CBUCVU: '',
            Alias: '',
            usePaymentPin: false,
            showModalPinValidation: false,
            itemContact: null,
        };
    },

    computed: {
        filteredContacts() {
            return this.contacts.filter(x => 
                x.Name.toUpperCase().includes(this.contactsFilter.toUpperCase()) ||
                x.CBUCVU.includes(this.contactsFilter)
            );
        }
    },
    methods: {
        async getTransferenceContacts(context) {
            axiosHelpers.axiosPost(
                "TransferenceContact/GetTransferenceContacts", 
                {}, 
                context, 
                function(data) {
                    context.contacts = data.ResponseVM.Contacts;
                }
            );
        },
        preDeleteContact(item){
            let context = this;
            context.itemContact = item;
            context.pinValidate();
        },
        deleteContact() {
            let context = this;
            let contact = context.itemContact;
            // -- Confirmacion
            confirmHelper.showConfirm(
                "¿Esta seguro que desea eliminar el contacto " + contact.Name + "?",
                this,
                function() {
                    // -- En caso que la confirmacion sea aceptada
                    axiosHelpers.axiosPost(
                        "TransferenceContact/DeleteContact",
                        { ContactID: contact.EntityID },
                        context,
                        function(data) {
                            if (data.ResponseVM.Success) {
                                notificationHelpers.showSuccess(
                                    "Exito",
                                    "Contacto eliminado correctamente",
                                    context
                                );

                                context.getTransferenceContacts(context);
                            }
                        }
                    );
                }
            );
        },
        addContact() {
            this.$router.push('NuevoDestinatario');
        },
        verDetallesContacto(contacto) {
            this.Referencia = contacto.Name;
            this.NombresPropietarios = contacto.NameOwners;
            this.CuitCuilPropietarios = contacto.CuitCuilOwners;
            this.Banco = contacto.BankName;
            this.CBUCVU = contacto.CBUCVU;
            this.Alias = contacto.Alias;
            this.mostrarModalDetallesContacto = true;
        },
        cerrarModalDetallesContacto() {
            this.mostrarModalDetallesContacto = false;
        },
        onValidPin(val) {
            let context = this;
            if(val) {
                context.deleteContact();
            }
        },
        onLoadUsePaymentPin(val) {
           let context = this;
           context.usePaymentPin = val;
        },
        pinValidate() {
            let context = this;
            if(context.usePaymentPin) {
                context.showModalPinValidation = true;
            } else {
                context.deleteContact();
            }
        }
    },
    beforeMount() {
        this.getTransferenceContacts(this);
    }
}
</script>